import { useQuery } from '@tanstack/react-query';
import { fetchAssignedStores, type AssignedStore } from '@/lib/api/stores';
import { useHostessStore } from '@/stores/hostess';

/**
 * ホステスの所属店舗履歴を取得するフック（過去+現在）
 * @returns TanStack Queryの戻り値
 */
export function useAssignedStores() {
  const { hostess } = useHostessStore();
  const hostessId = hostess?.id;

  return useQuery<AssignedStore[]>({
    queryKey: ['assigned-stores', hostessId],
    queryFn: () => fetchAssignedStores(hostessId!),
    enabled: !!hostessId,
    staleTime: 1000 * 60 * 30, // 30分キャッシュ
  });
}
